/**
 * Utility functions for route and URL generation
 */

import { generateUniqueSlug } from "@/services/photoStorage";

/**
 * Generate the full upload URL for a brand's upload page
 */
export const generateUploadUrlLink = (brand: { name: string; id: string }): string => {
  const slug = generateUniqueSlug(brand.name, brand.id);
  return `${window.location.origin}/uploads/${slug}`;
}; 